















import { defineComponent, PropType } from "vue";

export type CoverageAnalysesResultEnum = "coverage" | "authorization" | "request";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true
    },
    result: {
      type: String as PropType<CoverageAnalysesResultEnum>,
      required: true,
      validator: function (value: string) {
        const isValid = ["coverage", "authorization", "request"].includes(value);
        if (!isValid) {
          console.error("Property 'result' dont belong to CoverageAnalysesResultEnum");
        }
        return isValid;
      }
    },
    isDut: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    color() {
      switch (this.result as CoverageAnalysesResultEnum) {
        case "coverage":
          return "var(--colors-light-support-success)";
        case "request":
          return "var(--colors-light-support-error)";
        case "authorization":
          return "var(--colors-light-support-warning)";
      }
    },
    icon() {
      switch (this.result as CoverageAnalysesResultEnum) {
        case "coverage":
          return "circle-check";
        case "request":
          return "circle-xmark";
        case "authorization":
          return "circle-exclamation";
      }
    },
    text() {
      switch (this.result as CoverageAnalysesResultEnum) {
        case "coverage":
          return "Exame com cobertura: Sim <br/> Necessita de autorização prévia: Não";
        case "request":
          return "Exame <strong>não encontrado</strong>. Envie o pedido médico para análise de cobertura.";
        case "authorization":
          return "Exame com cobertura: Sim <br/> Necessita de autorização prévia: Sim";
      }
    },
    textDut() {
      switch (this.result as CoverageAnalysesResultEnum) {
        case "coverage":
          return "Necessita de autorização prévia: Não";
        case "request":
          return "Exame <strong>não encontrado</strong>. Envie o pedido médico para análise de cobertura.";
        case "authorization":
          return "Necessita de autorização prévia: Sim";
      }
    }
  }
});
